import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import arrow from "../assets/arrow.png";
import { url, ak } from "../pages/HomePage";
import './custom-scrollbar.css';


const categories = [
  "Kotisairaanhoito",
  "Kotihoito",
  "Henkilökohtainen avustus",
  "Lastenhoito",
  "Siivous",
];

function EmployeeInfo() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [currentGigs, setCurrentGigs] = useState([]);
  const [previousGigs, setPreviousGigs] = useState([]);
  const [workHours, setWorkHours] = useState([]);
  const [openPastMonths, setOpenPastMonths] = useState({});
  const [openWorkHoursMonths, setOpenWorkHoursMonths] = useState({});

  useEffect(() => {
    // /admin/gigs/user/done/:user-id
    fetch(url + `/admin/gigs/user/reserved/${state.id}` + ak, {
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setCurrentGigs(Array.isArray(data) ? data : []);
      });

    fetch(url + `/admin/gigs/user/done/${state.id}` + ak, {
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setPreviousGigs(Array.isArray(data) ? data : []);

        setOpenPastMonths({});
      });

    fetch(url + `/admin/user/${state.id}/work-hours` + ak, {
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Työtuntien haku epäonnistui");
        }
        return response.json();
      })
      .then((data) => {
        const months = Array.isArray(data) ? data : [];
        setWorkHours(months);

        setOpenWorkHoursMonths({});
      })
      .catch((error) => {
        console.error(error);
        setWorkHours([]);
      });
  }, [state.id]);

/*   function formatDate(dateString) {
    const date = new Date(dateString);
    
    // Backend sends UTC times, but we need to display them as local Helsinki time.
    // Convert UTC to Helsinki by getting the timezone offset and adjusting.
    const tzOffsetMinutes = date.getTimezoneOffset();
    
    // Create a new date representing the UTC time, then display it without further timezone adjustment
    const utcDate = new Date(date.getTime() + tzOffsetMinutes * 60 * 1000);

    const formattedDate = utcDate.toLocaleDateString("fi-FI");
    const formattedTime = utcDate.toLocaleTimeString("fi-FI").slice(0, -3);

    return `${formattedDate} kello ${formattedTime}`;
  } */

  function formatGigDate(dateString) {
    // For gigs fetched from /admin/gigs/user/*, times are already in local time
    // Just format without any offset conversion
    const date = new Date(dateString);

    const formattedDate = date.toLocaleDateString("fi-FI");
    const formattedTime = date.toLocaleTimeString("fi-FI").slice(0, -3);

    return `${formattedDate} kello ${formattedTime}`;
  }

  function formatWorkMinutes(minutes) {
    const hours = (minutes || 0) / 60;
    return `${hours.toLocaleString("fi-FI", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })} h`;
  }

  function getFinalWorkTime(gig) {
    for (const month of workHours) {
      const row = (month.rows || []).find(
        (item) => Number(item.gig_id) === Number(gig.id)
      );

      if (row) {
        return {
          start: row.start,
          end: row.end,
        };
      }
    }

    return {
      start: gig.start,
      end: gig.end,
    };
  }

  function createCategoriesList() {
    var tmpCategories = [];

    if (state.categories === null) {

    } else {
      state.categories.map((i) => {
        if (i === 1) {
          tmpCategories.push(categories[0]);
        } else if (i === 2) {
          tmpCategories.push(categories[1]);
        } else if (i === 3) {
          tmpCategories.push(categories[2]);
        } else if (i === 4) {
          tmpCategories.push(categories[3]);
        } else if (i === 5) {
          tmpCategories.push(categories[4]);
        } else {
          tmpCategories.push(categories[5]);
        }
        return null;
      });
    }

    return tmpCategories;
  }

  return (
    <div className="flex flex-col w-full h-[90%] items-center justify-center relative">
      <img
        src={arrow}
        alt="takaisin"
        className="absolute h-6 px-8 mb-4 cursor-pointer top-16 left-10"
        onClick={() => window.history.back()}
      ></img>
      <div className="flex flex-row items-center w-[95%]">
        <div className="flex flex-col justify-between w-1/4 p-5 h-4/5 card">
          <h1 className="text-2xl font-bold">Tiedot</h1>
          <br />
          <div className="overflow-scroll">
            <p className="text-xl">
              <b>Käyttäjänimi: </b>
              {state.username}
            </p>
            <p className="text-xl">
              <b>Etunimi: </b>
              {state.first_name || ""}
            </p>
            <p className="text-xl">
              <b>Sukunimi: </b>
              {state.last_name || ""}
            </p>
            <p className="text-xl">
              <b>Työntekijänumero: </b>
              {state.employee_number || ""}
            </p>
            <p className="text-xl">
              <b>Sukupuoli: </b>
              {state.gender}
            </p>
            <p className="text-xl">
              <b>Sähköposti: </b>
              {state.email}
            </p>
            <p className="text-xl">
              <b>Puhelin: </b>
              {state.phone}
            </p>
            <p className="text-xl">
              <b>Postinumero: </b>
              {state.postnumber}
            </p>
            <p className="text-xl">
              <b>Alueet missä työskentelee: </b>
              {state.cities.toString().replaceAll(",", ", ")}
            </p>
            <p className="text-xl">
              <b>Ajokortti: </b>
              {state.drivingLicence ? "On" : "Ei ole"}
            </p>
            <p className="text-xl">
              <b>Auto: </b>
              {state.car ? "On" : "Ei ole"}
            </p>
            <p className="text-xl">
              <b>Kategoriat: </b>
              {createCategoriesList().toString().replaceAll(",", ", ")}
            </p>
            <p className="text-xl">
              <b>Kielet: </b>
              {state.languages.toString().replaceAll(",", ", ")}
            </p>
            <p className="text-xl">
              <b>Rikosrekisteri tarkistettu: </b>
              {state.cr_checked ? "Kyllä" : "Ei"}
            </p>
            {state.cr_checked ? (
              <div>
                {" "}
                <p className="text-xl">
                  <b>Tarkistus ajankohta: </b>
                  {state.cr_check_date}
                </p>
                <p className="text-xl">
                  <b>Tarkistaja: </b>
                  {state.cr_checker}
                </p>
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <br />
          <button
            className="h-12 text-lg font-bold text-white rounded bg-main w-44 drop-shadow-md"
            onClick={() =>
              navigate("/tyontekija/hallinnointi", {
                state: {
                  id: state.id,
                  username: state.username,
                  fullname: state.fullname,
                  first_name: state.first_name,
                  last_name: state.last_name,
                  employee_number: state.employee_number,
                  gender: state.gender,
                  email: state.email,
                  phone: state.phone,
                  privilege: state.privilege,
                  postnumber: state.postnumber,
                  address: state.address,
                  cities: state.cities,
                  drivers_licence: state.drivers_licence,
                  car: state.car,
                  categories: state.categories,
                  current_gigs: state.current_gigs,
                  previous_gigs: state.previous_gigs,
                  languages: state.languages,
                  account_created: state.account_created,
                  cr_checked: state.cr_checked,
                  cr_check_date: state.cr_check_date,
                  cr_checker: state.cr_checker,
                  only_necessary_msgs: state.only_necessary_msgs,
                },
              })
            }
          >
            Muokkaa
          </button>
        </div>
        <div className="w-[10px] bg-transparent h-full"></div>
        <div className="flex flex-col w-1/4 p-5 card h-4/5">
          <h1 className="text-2xl font-bold">Tulevat keikat</h1>
          <br />
          <div className="w-full overflow-y-scroll h-96">
            {state.current_gigs !== null ? (
              [...currentGigs]
                .filter((gig) => new Date(gig.end).getTime() > Date.now())
                .sort((a, b) => new Date(b.start) - new Date(a.start))
                .map((i) => {
                return (
                  <div
                    className="flex flex-col w-full p-1 mb-4 cursor-pointer h-18 bg-card"
                    onClick={() =>
                      navigate("/keikka/tiedot", {
                        state: {
                          id: i.id,
                          pubd: i.pubd,
                          title: i.title,
                          public_description: i.public_description,
                          confidential_description: i.confidential_description,
                          start: i.start,
                          end: i.end,
                          address: i.address,
                          city: i.city,
                          category: i.category,
                          language: i.language,
                          status: i.status,
                          user: i.user,
                          added_by: i.added_by,
                          report: i.report,
                          admin_title: i.admin_title,
                          customer: i.customer,
                        },
                      })
                    }
                  >
                    <div className="flex flex-row justify-between w-full h-1/2">
                      <p className="text-black">
                        <b>{i.title}</b>
                      </p>
                      <p className="text-black">{i.address}</p>
                    </div>
                    <div className="flex flex-row justify-between w-full h-1/2">
                      <b>Alkaa: </b>
                      <p className="w-auto text-black">{formatGigDate(i.start)}</p>
                      {/* <p className="w-auto text-black">{formatGigDate(i.end).replace("at", "").replace("AM", "").replace("PM", "")}</p> */}
                    </div>
                  </div>
                );
              })
            ) : (
              <div>Ei keikkoja</div>
            )}
          </div>
        </div>
        <div className="w-[10px] bg-transparent h-full"></div>
        <div className="flex flex-col w-1/4 p-5 card h-4/5">
          <h1 className="text-2xl font-bold">Menneet keikat</h1>
          <br />
          <div className="w-5/6 overflow-y-scroll h-96 scrollbar">
            {(
              Object.entries(
                [
                  ...previousGigs,
                  ...currentGigs.filter(
                    (gig) => new Date(gig.end).getTime() <= Date.now()
                  ),
                ]
                  .filter(
                    (gig, index, all) =>
                      all.findIndex(
                        (item) => Number(item.id) === Number(gig.id)
                      ) === index
                  )
                  .sort((a, b) => new Date(b.start) - new Date(a.start))
                  .reduce((months, gig) => {
                    const date = new Date(gig.start);
                    const key = `${date.getFullYear()}-${String(
                      date.getMonth() + 1
                    ).padStart(2, "0")}`;

                    if (!months[key]) {
                      months[key] = [];
                    }

                    months[key].push(gig);
                    return months;
                  }, {})
              ).map(([monthKey, gigs]) => {
                const [year, month] = monthKey.split("-");
                const monthName = new Date(
                  Number(year),
                  Number(month) - 1,
                  1
                ).toLocaleDateString("fi-FI", {
                  month: "long",
                  year: "numeric",
                });

                return (
                  <div key={monthKey} className="mb-6">
                    <div
                      className="sticky top-0 z-10 flex items-center justify-between p-2 mb-3 bg-gray-200 rounded cursor-pointer"
                      onClick={() =>
                        setOpenPastMonths((current) => ({
                          ...current,
                          [monthKey]: !current[monthKey],
                        }))
                      }
                    >
                      <h2 className="text-lg font-bold capitalize">
                        {monthName}
                      </h2>
                      <span className="px-2 text-2xl font-bold">
                        {openPastMonths[monthKey] ? "−" : "+"}
                      </span>
                    </div>

                    {openPastMonths[monthKey] &&
                      gigs.map((i) => (
                      <div
                        key={i.id}
                        className="flex flex-col w-full p-1 mb-4 h-18 bg-card"
                        onClick={() =>
                          navigate("/keikka/tiedot", {
                            state: {
                              id: i.id,
                              pubd: i.pubd,
                              title: i.title,
                              public_description: i.public_description,
                              confidential_description: i.confidential_description,
                              start: getFinalWorkTime(i).start,
                              end: getFinalWorkTime(i).end,
                              address: i.address,
                              city: i.city,
                              category: i.category,
                              language: i.language,
                              status: i.status,
                              user: i.user,
                              added_by: i.added_by,
                              report: i.report,
                              admin_title: i.admin_title,
                              customer: i.customer,
                            },
                          })
                        }
                      >
                        <div className="flex flex-row justify-between w-full h-1/2">
                          <p className="text-black">
                            <b>{i.title}</b>
                          </p>
                          <p className="text-black">{i.address}</p>
                        </div>

                        <div className="flex flex-row justify-between w-full h-1/2">
                          <b>Alkoi: </b>
                          <p className="w-auto text-black">
                            {formatGigDate(getFinalWorkTime(i).start)}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })
            )}
          </div>
        </div>

        <div className="w-[10px] bg-transparent h-full"></div>

        <div
          className="flex flex-col w-1/4 p-5 cursor-pointer card h-4/5"
          onClick={() =>
            navigate("/tyontekija/tyotunnit", {
              state: {
                id: state.id,
                fullname: state.fullname,
              },
            })
          }
        >
          <h1 className="text-2xl font-bold">Työtunnit</h1>
          <br />

          <div className="w-full overflow-y-scroll h-96 scrollbar">
            {workHours.length > 0 ? (
              workHours.map((month) => {
                const [year, monthNumber] = month.month.split("-");
                const monthName = new Date(
                  Number(year),
                  Number(monthNumber) - 1,
                  1
                ).toLocaleDateString("fi-FI", {
                  month: "long",
                  year: "numeric",
                });

                return (
                  <div key={month.month} className="mb-6">
                    <div
                      className="sticky top-0 z-10 flex items-center justify-between p-2 mb-3 bg-gray-200 rounded cursor-pointer"
                      onClick={(event) => {
                        event.stopPropagation();
                        setOpenWorkHoursMonths((current) => ({
                          ...current,
                          [month.month]: !current[month.month],
                        }));
                      }}
                    >
                      <h2 className="text-lg font-bold capitalize">
                        {monthName}
                      </h2>
                      <span className="px-2 text-2xl font-bold">
                        {openWorkHoursMonths[month.month] ? "−" : "+"}
                      </span>
                    </div>

                    {openWorkHoursMonths[month.month] && (
                      <div className="text-sm">
                      <p>
                        <b>Perustunnit:</b>{" "}
                        {formatWorkMinutes(month.totals.base_minutes)}
                      </p>
                      <p>
                        <b>Ilta 18–21:</b>{" "}
                        {formatWorkMinutes(month.totals.evening_minutes)}
                      </p>
                      <p>
                        <b>Yö 21–06:</b>{" "}
                        {formatWorkMinutes(month.totals.night_minutes)}
                      </p>
                      <p>
                        <b>Lauantai:</b>{" "}
                        {formatWorkMinutes(month.totals.saturday_minutes)}
                      </p>
                      <p>
                        <b>Sunnuntai/pyhä:</b>{" "}
                        {formatWorkMinutes(
                          month.totals.sunday_holiday_minutes
                        )}
                      </p>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div>Ei työtunteja</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeeInfo;
